module.exports = __webpack_public_path__ + "img/icons.6ffe01bf.png";